import { z } from "zod";

export const deliveryNoteRowSchema = z.object({
  id: z.string().min(1).max(100),
  articleNumber: z.string().max(200),
  material: z.string().max(10000),
  quantity: z.number().finite().min(0).max(1e9).nullable(),
  unit: z.string().max(40),
  notes: z.string().max(10000),
  unitPrice: z.number().finite().min(0).max(1e9).nullable(),
  selected: z.boolean(),
  appliedItemId: z.string().max(100).nullable(),
});

export const deliveryNoteSchema = z.object({
  id: z.string().min(1).max(100),
  fileName: z.string().min(1).max(255),
  deliveryNumber: z.string().max(200),
  deliveryDate: z.string().max(100),
  warnings: z.array(z.string().max(2000)).max(30),
  rows: z.array(deliveryNoteRowSchema).max(200),
});

export const deliveryNoteUploadSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.enum(["application/pdf", "image/jpeg", "image/png", "image/webp"]),
  data: z.string().min(1).max(20 * 1024 * 1024).regex(/^[A-Za-z0-9+/]+={0,2}$/),
});

export type DeliveryNote = z.infer<typeof deliveryNoteSchema>;
export type DeliveryNoteRow = z.infer<typeof deliveryNoteRowSchema>;
export type DeliveryNoteUpload = z.infer<typeof deliveryNoteUploadSchema>;
